import { DEFAULT_REGION_ID, normalizeRegionId } from './region-cookie';
import { fetchShowtimePrices, formatShowtimePrice } from './showtime-prices';

function appendShowtimePriceSource(container, node) {
  if (!node) {
    return;
  }

  if (node.nodeType === Node.DOCUMENT_NODE || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
    Array.from(node.childNodes).forEach(function(childNode) {
      container.appendChild(childNode.cloneNode(true));
    });
    return;
  }

  if (node.nodeType === Node.ELEMENT_NODE) {
    container.appendChild(node.cloneNode(true));
  }
}

if (typeof window.getRegion !== 'function') {
  window.getRegion = function() {
    const rawRegion = window.Cookies.get('region');
    const regionId = normalizeRegionId(rawRegion);

    if (regionId !== null) {
      return regionId;
    }

    // Cookie CÓ mặt nhưng hỏng: ghi đè bằng mặc định thay vì chỉ bỏ qua, xem MVK-3037.
    if (typeof rawRegion !== 'undefined') {
      window.Cookies.set('region', DEFAULT_REGION_ID, { expires: 365 });
    }

    return DEFAULT_REGION_ID;
  };
}

if (typeof window.setRegion !== 'function') {
  window.setRegion = function(region) {
    const regionId = normalizeRegionId(region);

    // Không bao giờ ghi giá trị hỏng vào cookie — xem MVK-3037.
    if (regionId === null) {
      return;
    }

    window.Cookies.set('region', regionId, { expires: 365 });
  };
}

if (typeof window.getCinema !== 'function') {
  window.getCinema = function() {
    const currentCinema = window.Cookies.get('cinema');

    return typeof currentCinema === 'undefined' ? '' : currentCinema;
  };
}

if (typeof window.setCinema !== 'function') {
  window.setCinema = function(cinema) {
    window.Cookies.set('cinema', cinema, { expires: 365 });
  };
}

if (typeof window.getTutorial !== 'function') {
  window.getTutorial = function(key) {
    const tutorial = window.Cookies.get('mvk_tutorial_' + key);

    return typeof tutorial === 'undefined' ? 0 : tutorial;
  };
}

if (typeof window.setTutorial !== 'function') {
  window.setTutorial = function(key, value) {
    window.Cookies.set('mvk_tutorial_' + key, value, { expires: 365 });
  };
}

if (typeof window.doGetShowtimePrice !== 'function') {
  window.doGetShowtimePrice = function(data) {
    const showtimes = [];
    const container = document.createElement('div');

    if (typeof data === 'string') {
      container.innerHTML = data;
    } else if (data instanceof Element || data instanceof Document || data instanceof DocumentFragment) {
      appendShowtimePriceSource(container, data);
    } else if (typeof data === 'object' && typeof data.length === 'number') {
      Array.prototype.forEach.call(data, function(node) {
        if (node && node.nodeType) {
          appendShowtimePriceSource(container, node);
        }
      });
    }

    container.querySelectorAll('.btn-showtime.is-show-price').forEach(function(showtimeButton) {
      const reference = showtimeButton.getAttribute('data-reference');

      if (reference) {
        showtimes.push(reference);
      }
    });

    if (showtimes.length === 0) {
      return;
    }

    // MVK-3312 — giá từ booking-service, không còn qua `POST /showtime/price` của PHP. Lỗi ⇒ chip không
    // giá; `fetchShowtimePrices` không bao giờ reject, `.catch` ở đây chỉ chặn lỗi DOM bất ngờ.
    fetchShowtimePrices(showtimes, window.axios)
      .then(function(prices) {
        Object.keys(prices).forEach(function(key) {
          const label = formatShowtimePrice(prices[key]);

          if (label === '') {
            return;
          }

          document.querySelectorAll('.btn-showtime[data-reference="' + key + '"]').forEach(function(showtimeButton) {
            const priceElement = showtimeButton.querySelector('.amenity.price');

            if (priceElement) {
              priceElement.textContent = label;
              return;
            }

            showtimeButton.insertAdjacentHTML('beforeend', '<span class="amenity price">' + label + '</span>');
          });
        });
      })
      .catch(function() {});
  };
}

if (typeof window.appendUtmToAffiliateLinks !== 'function') {
  window.appendUtmToAffiliateLinks = function() {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get('utm_campaign') !== 'SEO') {
      return;
    }

    document.querySelectorAll('.is-affiliate').forEach(function(link) {
      const href = link.getAttribute('href');

      if (!href) {
        return;
      }

      const separator = href.indexOf('?') !== -1 ? '&' : '?';

      if (href.indexOf('utm_campaign=SEO') === -1) {
        link.setAttribute('href', href + separator + 'utm_campaign=SEO');
      }
    });
  };
}
